// globals.ts
import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  urlMain  = 'http://api.milmedia.am/api/';
  // urlMain  = 'http://127.0.0.1:8000/api/';
}
